export function getQueryString(name: string): any {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2]!)
  }
  return null
}

export function urlParse(url: string) {
  let arr = []
  const obj = {}
  if (url.indexOf('?') !== -1) {
    const parseStr = url.split('?')[1]
    if (parseStr.indexOf('&') !== -1) {
      arr = parseStr.split('&')
      for (let i = 0; i < arr.length; i++) {
        obj[arr[i].split('=')[0]] = arr[i].split('=')[1]
      }
    } else {
      obj[parseStr.split('=')[0]] = parseStr.split('=')[1]
    }
  }
  return obj
}

export function addQueryString(url: string, params: any): string {
  // 分离 URL 的路径和 hash 部分
  const [baseUrl, hash] = url.split('#')

  // 创建 URL 对象
  let urlObj: URL
  try {
    urlObj = new URL(baseUrl, window.location.origin)
  } catch (e) {
    // 如果 baseUrl 不是绝对路径，则使用当前 origin
    urlObj = new URL(window.location.origin + baseUrl)
  }

  // 拼接查询参数
  Object.keys(params).forEach((key) => {
    if (Array.isArray(params[key])) {
      params[key].forEach((value: any) => {
        urlObj.searchParams.append(key, value)
      })
    } else {
      urlObj.searchParams.append(key, params[key])
    }
  })

  // 重新组合 URL，确保 hash 在查询参数之后
  const finalUrl = `${urlObj.origin}${urlObj.pathname}${
    hash ? `#${hash}` : ''
  }${urlObj.search}`
  return finalUrl
}
function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function jsonToQuery(json: any): string {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(function (key) {
      if (typeof json[key] === 'undefined') return ''
      return key + '=' + json[key]
      // return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    }),
  ).join('&')
}

/**
 * 判断当前是否为指定后缀域名
 */
export function checkDomainSuffix(suffix: string): boolean {
  const url = new URL(window.location.href)

  return url.hostname.endsWith(suffix)
}

export function isCNSuffix(): ReturnType<typeof checkDomainSuffix> {
  return checkDomainSuffix('.cn')
}

/**
 * 获取是否为debug模式
 * @returns boolean
 */
export function isDebugMode(): boolean {
  const debug = getQueryString('debug')
  return debug === 'true'
}
